<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">credit_card</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" [routerLink]="" (click)="extraOptions.close(data)">{{ data.mccLibelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li><strong [translate]="'ndf.frais.fraisCarte.carte'"></strong> {{ data.numCarte }}  </li>
            <li><strong [translate]="'ndf.frais.fraisCarte.date'"></strong> {{ data.dateVente | date:'shortDate' }}</li>
            <li><strong [translate]="'ndf.frais.fraisCarte.montantAchat'"></strong> {{ data.montantAchat | number:'1.2-2' }} {{ data.deviseAchat }}</li>
            <li><strong [translate]="'ndf.frais.fraisCarte.commercant'"></strong> {{ data.enseigne }} ({{ data.localite }})</li>
            <li><strong [translate]="'ndf.frais.fraisCarte.montantRestant'"></strong> {{ data.montantRestant | number:'1.2-2' }} {{ data.deviseAchat }}</li>
        </ul>
    </div>
    <div class="info">
        <div>
            <div class="text-end text-secondary fw-bold">
                {{ data.montantReglement | number:'1.2-2' }} {{ data.deviseReglement }}
            </div>
        </div>
    </div>
</div>